import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { ThreeDotsIcon } from '../components/icons/ThreeDotsIcon'
type SpeechBalloonProps = {
  children: ReactNode
  sender: 'user' | 'bot'
  isLast?: boolean
}

export const SpeechBalloon: FC<SpeechBalloonProps> = (props) => {
  const { children, sender, isLast } = props

  const [canRender, setCanRender] = useState(false)
  const [speechBalloonHeight, setSpeechBalloonHeight] = useState<number>()
  const dannyDivRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const height = dannyDivRef.current?.clientHeight
    setSpeechBalloonHeight(height)
    setTimeout(() => {
      setCanRender(true)
    }, 2000)
  }, [])

  return (
    <>
      {sender === 'user' || canRender ? (
        <StyledDiv sender={sender} isLast={isLast} speechBalloonHeight={speechBalloonHeight}>
          <pre>{children}</pre>
        </StyledDiv>
      ) : (
        <StyledLoading sender={sender} isLast={isLast} speechBalloonHeight={speechBalloonHeight}>
          <ThreeDotsIcon />
        </StyledLoading>
      )}

      <StyledHiddenDiv>
        <StyledDannyDiv ref={dannyDivRef}>
          <pre>{children}</pre>
        </StyledDannyDiv>
      </StyledHiddenDiv>
    </>
  )
}

const moveVertically = (height?: number) => keyframes`
  0% {
    width: 68px;
    height: 28px;
    color: transparent;
  }
  99% {
    color: transparent;
  }
  100% {
    width: 100%;
    height: ${height}px;
  }
`

type StyledDivType = Pick<SpeechBalloonProps, 'sender' | 'isLast'> & {
  speechBalloonHeight?: number
}

const fadeAndSlideUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px) 
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateY(0) 
  }
`

const speechBalloonStyle = ({ sender, isLast }: Pick<SpeechBalloonProps, 'sender' | 'isLast'>) => css`
  font-size: 15px;
  border-radius: 18px;
  transition: 0.5s;

  ${() =>
    sender === 'user'
      ? css`
          background: #3e9f26;
          color: #fff;
        `
      : css`
          background: rgb(246 247 248);
          color: #333;
        `}
  ${() =>
    sender === 'user' && isLast
      ? css`
          border-bottom-right-radius: 0;
        `
      : sender === 'bot' &&
        isLast &&
        css`
          border-bottom-left-radius: 0;
        `}
`

const StyledLoading = styled.div<StyledDivType>`
  padding: 0 16px;
  height: 28px;
  width: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeAndSlideUp} 0.4s;
  ${(props) => speechBalloonStyle(props)}
`
const StyledDiv = styled.div<StyledDivType>`
  border-radius: 18px;
  display: inline-block;
  overflow: hidden;
  will-change: animation;
  padding: 8px 16px;
  min-height: 28px;
  min-width: 68px;
  font-size: 15px;
  will-change: animation;
  ${(props) => speechBalloonStyle(props)};
  animation: ${({ speechBalloonHeight }) => moveVertically(speechBalloonHeight)} 0.5s;
`
const StyledDannyDiv = styled.div`
  display: inline-block;
  overflow: hidden;
  padding: 8px 16px;
  min-height: 28px;
  min-width: 68px;
  font-size: 15px;
`
const StyledHiddenDiv = styled.div`
  opacity: 0;
  position: absolute;
  left: 0;
`
